<script setup>
import { defineEmits, defineProps } from "vue";

const emits = defineEmits(["close"]);
const props = defineProps({
  callQnaName: {
    type: String,
    required: true,
  },
  callQnaNumber: {
    type: String,
    required: true,
  },
  callQnaTime: {
    type: String,
    required: true,
  },
});
const changeTel = (telOrigin) => {
  let tel = telOrigin
    .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
    .replace(/-{1,2}$/g, "");
  return tel;
};
</script>

<template>
  <div class="popup-bg on" @click="emits('close')"></div>
  <div class="popup-cont w01 on" id="popup-call">
    <div class="popup-header">
      <h3 class="title">전화문의</h3>
      <button
        type="button"
        class="popup-close-btn popup-close"
        @click="emits('close')"
      >
        닫기
      </button>
    </div>
    <div class="popup-body">
      <div class="call_wrap">
        <p class="name">{{ props.callQnaName }}</p>
        <p class="num mont">{{ changeTel(props.callQnaNumber) }}</p>
        <dl class="call_info">
          <dt>상담가능시간</dt>
          <dd>
            {{ callQnaTime }}
          </dd>
        </dl>
        <div class="btn_area">
          <button type="button" class="btn popup-close" @click="emits('close')">
            확인
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
